"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * ChiRhos API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class GroupApi extends runtime.BaseAPI {
    /**
     * Leave the \'ToPersonEntityId\' and \'RoleLimit\' blank to send to all members of this group. If you set both the ToPersonEntityId and RoleLimit fields they will be combined
     */
    apiGroupCreateNotificationPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/CreateNotification`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiNotificationRequestToJSON(requestParameters.apiNotificationRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Leave the \'ToPersonEntityId\' and \'RoleLimit\' blank to send to all members of this group. If you set both the ToPersonEntityId and RoleLimit fields they will be combined
     */
    apiGroupCreateNotificationPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiGroupCreateNotificationPostRaw(requestParameters);
        });
    }
    /**
     */
    apiGroupDeleteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.entityId !== undefined) {
                queryParameters['entityId'] = requestParameters.entityId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Group`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiGroupDelete(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiGroupDeleteRaw(requestParameters);
        });
    }
    /**
     * Deletes a distribution list
     */
    apiGroupDistributionListDeleteEntityIdDeleteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.entityId === null || requestParameters.entityId === undefined) {
                throw new runtime.RequiredError('entityId', 'Required parameter requestParameters.entityId was null or undefined when calling apiGroupDistributionListDeleteEntityIdDelete.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Group/DistributionList/Delete/{entityId}`.replace(`{${"entityId"}}`, encodeURIComponent(String(requestParameters.entityId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes a distribution list
     */
    apiGroupDistributionListDeleteEntityIdDelete(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiGroupDistributionListDeleteEntityIdDeleteRaw(requestParameters);
        });
    }
    /**
     * Gets a distribution list
     */
    apiGroupDistributionListGetPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/DistributionList/Get`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IDistributionListIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Gets a distribution list
     */
    apiGroupDistributionListGetPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupDistributionListGetPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Lists distribution lists for a group
     */
    apiGroupDistributionListListPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/DistributionList/List`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IDistributionListIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Lists distribution lists for a group
     */
    apiGroupDistributionListListPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupDistributionListListPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Gets all members for a distribution list
     */
    apiGroupDistributionListMembersPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/DistributionList/Members`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityPagedRequestToJSON(requestParameters.apiEntityPagedRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonIStorablePagedResponseFromJSON(jsonValue));
        });
    }
    /**
     * Gets all members for a distribution list
     */
    apiGroupDistributionListMembersPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupDistributionListMembersPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiGroupDistributionListNotificationPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/DistributionList/Notification`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiDistributionListNotificationRequestToJSON(requestParameters.apiDistributionListNotificationRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiGroupDistributionListNotificationPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiGroupDistributionListNotificationPostRaw(requestParameters);
        });
    }
    /**
     * Saves a distribution list to the group. Distribution lists with isOpen set will include everyone in this organisation.
     */
    apiGroupDistributionListPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/DistributionList`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.DistributionListConstructToJSON(requestParameters.distributionListConstruct),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IDistributionListIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Saves a distribution list to the group. Distribution lists with isOpen set will include everyone in this organisation.
     */
    apiGroupDistributionListPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupDistributionListPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiGroupFavouriteAddPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/Favourite/Add`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRawRequestToJSON(requestParameters.apiEntityRawRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiGroupFavouriteAddPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiGroupFavouriteAddPostRaw(requestParameters);
        });
    }
    /**
     * Currently supports retrieval of up to 50 group records at once
     */
    apiGroupGetMultiplePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/GetMultiple`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityMultipleRequestToJSON(requestParameters.apiEntityMultipleRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IGroupIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Currently supports retrieval of up to 50 group records at once
     */
    apiGroupGetMultiplePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupGetMultiplePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiGroupGetPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/Get`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IGroupIStorableIDataSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGroupGetPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupGetPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiGroupGetUsagePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/GetUsage`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.GroupUsageResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGroupGetUsagePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupGetUsagePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     */
    apiGroupImportPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.entityId !== undefined) {
                queryParameters['entityId'] = requestParameters.entityId;
            }
            if (requestParameters.importIdentifier !== undefined) {
                queryParameters['importIdentifier'] = requestParameters.importIdentifier;
            }
            if (requestParameters.createDependencies !== undefined) {
                queryParameters['createDependencies'] = requestParameters.createDependencies;
            }
            const headerParameters = {};
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.file !== undefined) {
                formParams.append('file', requestParameters.file);
            }
            const response = yield this.request({
                path: `/api/Group/Import`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IImportIStorableFromJSON(jsonValue));
        });
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     */
    apiGroupImportPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupImportPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiGroupInviteAcceptGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.secret !== undefined) {
                queryParameters['secret'] = requestParameters.secret;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Group/Invite/Accept`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiGroupInviteAcceptGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiGroupInviteAcceptGetRaw(requestParameters);
        });
    }
    /**
     */
    apiGroupInvitePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/Invite`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.InviteConstructToJSON(requestParameters.inviteConstruct),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiGroupInvitePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiGroupInvitePostRaw(requestParameters);
        });
    }
    /**
     */
    apiGroupListChildGroupsPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/ListChildGroups`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityFilteredPagedRequestToJSON(requestParameters.apiEntityFilteredPagedRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IGroupIStorablePagedSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGroupListChildGroupsPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupListChildGroupsPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Can only be called by Tenant Owners or Administrators
     * Lists all descendants of a group
     */
    apiGroupListDescendantsPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/ListDescendants`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IGroupIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Can only be called by Tenant Owners or Administrators
     * Lists all descendants of a group
     */
    apiGroupListDescendantsPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupListDescendantsPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiGroupListRootGroupsPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/ListRootGroups`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiPagedFilteredRequestToJSON(requestParameters.apiPagedFilteredRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IGroupIStorablePagedResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGroupListRootGroupsPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupListRootGroupsPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Note that the Order and Sort are ignored for this call as it is ordered by ranking
     */
    apiGroupLookupPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/Lookup`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiSearchPagedRequestToJSON(requestParameters.apiSearchPagedRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IGroupPagedResponseFromJSON(jsonValue));
        });
    }
    /**
     * Note that the Order and Sort are ignored for this call as it is ordered by ranking
     */
    apiGroupLookupPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupLookupPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiGroupNoteGetPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/Note/Get`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.INoteIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGroupNoteGetPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupNoteGetPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiGroupNoteListPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/Note/List`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityFilteredPagedRequestToJSON(requestParameters.apiEntityFilteredPagedRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.INoteIStorablePagedResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGroupNoteListPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupNoteListPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiGroupNotePersonGetPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/Note/Person/Get`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.INoteIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGroupNotePersonGetPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupNotePersonGetPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Note that this lists all the notes for all persons for the specified group, not all the notes for a person. For a person\'s notes, use /api/Person/Note/List
     */
    apiGroupNotePersonListPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/Note/Person/List`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityFilteredPagedRequestToJSON(requestParameters.apiEntityFilteredPagedRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.INoteIStorablePagedResponseFromJSON(jsonValue));
        });
    }
    /**
     * Note that this lists all the notes for all persons for the specified group, not all the notes for a person. For a person\'s notes, use /api/Person/Note/List
     */
    apiGroupNotePersonListPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupNotePersonListPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiGroupNotePersonPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/Note/Person`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiAddNotePersonRequestToJSON(requestParameters.apiAddNotePersonRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.INoteIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGroupNotePersonPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupNotePersonPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiGroupNotePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/Note`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiAddNoteRequestToJSON(requestParameters.apiAddNoteRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.INoteIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGroupNotePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupNotePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiGroupPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.GroupConstructToJSON(requestParameters.groupConstruct),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IGroupIStorableIDataSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGroupPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiGroupReportDeleteDeleteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.entityId !== undefined) {
                queryParameters['entityId'] = requestParameters.entityId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Group/Report/Delete`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiGroupReportDeleteDelete(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiGroupReportDeleteDeleteRaw(requestParameters);
        });
    }
    /**
     */
    apiGroupReportListForGroupTypePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/Report/ListForGroupType`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IReportIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGroupReportListForGroupTypePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupReportListForGroupTypePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiGroupReportListPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/Report/List`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IReportIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGroupReportListPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupReportListPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiGroupReportRunPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/Report/Run`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ReportConstructToJSON(requestParameters.reportConstruct),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ReportResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGroupReportRunPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupReportRunPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiGroupReportSaveForGroupTypePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/Report/SaveForGroupType`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ReportConstructToJSON(requestParameters.reportConstruct),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiGroupReportSaveForGroupTypePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiGroupReportSaveForGroupTypePostRaw(requestParameters);
        });
    }
    /**
     */
    apiGroupReportSavePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/Report/Save`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ReportConstructToJSON(requestParameters.reportConstruct),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiGroupReportSavePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiGroupReportSavePostRaw(requestParameters);
        });
    }
    /**
     */
    apiGroupResourceDeletePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.entityId !== undefined) {
                queryParameters['entityId'] = requestParameters.entityId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Group/Resource/Delete`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiGroupResourceDeletePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiGroupResourceDeletePostRaw(requestParameters);
        });
    }
    /**
     */
    apiGroupResourceFilePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/Resource/File`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.StreamFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGroupResourceFilePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupResourceFilePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiGroupResourceListPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/Resource/List`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityFilteredPagedRequestToJSON(requestParameters.apiEntityFilteredPagedRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IResourceIStorablePagedSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGroupResourceListPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupResourceListPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Gets a resource file for a group. This call does not support point in time. For point in time requests, use [POST]Resource/File
     */
    apiGroupResourceResourceEntityIdFileNameGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.resourceEntityId === null || requestParameters.resourceEntityId === undefined) {
                throw new runtime.RequiredError('resourceEntityId', 'Required parameter requestParameters.resourceEntityId was null or undefined when calling apiGroupResourceResourceEntityIdFileNameGet.');
            }
            if (requestParameters.fileName === null || requestParameters.fileName === undefined) {
                throw new runtime.RequiredError('fileName', 'Required parameter requestParameters.fileName was null or undefined when calling apiGroupResourceResourceEntityIdFileNameGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Group/Resource/{resourceEntityId}/{fileName}`.replace(`{${"resourceEntityId"}}`, encodeURIComponent(String(requestParameters.resourceEntityId))).replace(`{${"fileName"}}`, encodeURIComponent(String(requestParameters.fileName))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.StreamFromJSON(jsonValue));
        });
    }
    /**
     * Gets a resource file for a group. This call does not support point in time. For point in time requests, use [POST]Resource/File
     */
    apiGroupResourceResourceEntityIdFileNameGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupResourceResourceEntityIdFileNameGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Gets a resource file for a group. This call does not support point in time. For point in time requests, use [POST]Resource/File
     */
    apiGroupResourceResourceEntityIdGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.resourceEntityId === null || requestParameters.resourceEntityId === undefined) {
                throw new runtime.RequiredError('resourceEntityId', 'Required parameter requestParameters.resourceEntityId was null or undefined when calling apiGroupResourceResourceEntityIdGet.');
            }
            const queryParameters = {};
            if (requestParameters.fileName !== undefined) {
                queryParameters['fileName'] = requestParameters.fileName;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Group/Resource/{resourceEntityId}`.replace(`{${"resourceEntityId"}}`, encodeURIComponent(String(requestParameters.resourceEntityId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.StreamFromJSON(jsonValue));
        });
    }
    /**
     * Gets a resource file for a group. This call does not support point in time. For point in time requests, use [POST]Resource/File
     */
    apiGroupResourceResourceEntityIdGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupResourceResourceEntityIdGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Pass in a multipart form with two parameters: file [File] and resourceJson [Text], with the resourceJson holding a ResourceConstruct
     */
    apiGroupResourceSavePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.resourceJson !== undefined) {
                queryParameters['resourceJson'] = requestParameters.resourceJson;
            }
            const headerParameters = {};
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.file !== undefined) {
                formParams.append('file', requestParameters.file);
            }
            const response = yield this.request({
                path: `/api/Group/Resource/Save`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IResourceIStorableIDataSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     * Pass in a multipart form with two parameters: file [File] and resourceJson [Text], with the resourceJson holding a ResourceConstruct
     */
    apiGroupResourceSavePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupResourceSavePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiGroupRestorePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.entityId !== undefined) {
                queryParameters['entityId'] = requestParameters.entityId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Group/Restore`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiGroupRestorePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiGroupRestorePostRaw(requestParameters);
        });
    }
    /**
     */
    apiGroupSearchReIndexPostRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Group/SearchReIndex`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.Int32IDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGroupSearchReIndexPost() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupSearchReIndexPostRaw();
            return yield response.value();
        });
    }
    /**
     */
    apiGroupSecurityPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/Security`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiSecurityRequestToJSON(requestParameters.apiSecurityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IGroupIStorableIDataSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGroupSecurityPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupSecurityPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiGroupSetSecurityPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/SetSecurity`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiSecurityRequestToJSON(requestParameters.apiSecurityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IGroupIStorableIDataSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGroupSetSecurityPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupSetSecurityPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiGroupUpdateSubscriptionPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Group/UpdateSubscription`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiSubscriptionUpdateRequestToJSON(requestParameters.apiSubscriptionUpdateRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IGroupIStorableIDataSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiGroupUpdateSubscriptionPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiGroupUpdateSubscriptionPostRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.GroupApi = GroupApi;
